import instance from '../xhrService';

const striepApi = {
    createCustomer(body: any): Promise<any> {
        return instance
            .post(`/api/payment/create-customer`, body)
            .then((res) => res.data);
    },

    createCardDetailsEntry(customerId: string, tenantId: number): Promise<any> {
        return instance
            .get(`/api/payment/customer/${customerId}/${tenantId}`)
            .then((res) => res.data);
    },

    createFreeTrialEntry(body: any): Promise<any> {
        return instance
            .post(`/api/free-trial/create`, body)
            .then((res) => res.data);
    }
    
};

export default striepApi;
